module.exports = "<p>detail-suppier works!</p>\n"